import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { IosCard } from "./IosParity";

function Row({ label, value }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1, py: 0.75 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          flex: "0 0 auto",
          maxWidth: "48%",
          overflowWrap: "anywhere",
          wordBreak: "break-word",
          whiteSpace: "normal",
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        fontWeight={700}
        sx={{
          textAlign: "right",
          minWidth: 0,
          overflowWrap: "anywhere",
          wordBreak: "break-word",
          whiteSpace: "normal",
        }}
      >
        {value ?? "—"}
      </Typography>
    </Box>
  );
}

Row.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
};

/**
 * Mobile-friendly card for key/value fields.
 */
export default function InfoCard({ title, rows, footer }) {
  return (
    <IosCard>
      {title ? (
        <Typography variant="subtitle2" fontWeight={900} sx={{ mb: 0.75 }}>
          {title}
        </Typography>
      ) : null}
      {rows.map((r, idx) => (
        <Box key={r.label}>
          <Row label={r.label} value={r.value} />
          {idx !== rows.length - 1 ? <Divider /> : null}
        </Box>
      ))}
      {footer ? <Box sx={{ mt: 1 }}>{footer}</Box> : null}
    </IosCard>
  );
}

InfoCard.propTypes = {
  title: PropTypes.string,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.node,
    })
  ).isRequired,
  footer: PropTypes.node,
};
